const FAQS = [
  {
    q: '日韩影视网真的完全免费吗？',
    a: '是的，日韩影视网所有日本电影和韩国电影资源完全免费在线观看，无需注册账号，无需付费订阅，打开网站即可直接播放。我们通过广告收入维持运营，致力于为影迷提供免费的日韩电影高清在线观看服务。',
  },
  {
    q: '日韩影视网的画质怎么样？支持什么清晰度？',
    a: '日韩影视网提供高清至超清多种画质选择，大部分影片支持1080P高清播放，部分热门影片提供4K画质。系统会根据您的网络状况自动选择最佳清晰度，您也可以在播放器中手动切换画质。',
  },
  {
    q: '可以在手机上观看日韩电影吗？',
    a: '当然可以！日韩影视网全面适配手机和平板浏览器，无需下载任何APP。在手机浏览器中打开网站即可流畅观看韩国电影免费资源和日本电影免费资源，画质自适应，流量模式下自动优化。',
  },
  {
    q: '影片更新频率是怎样的？',
    a: '日韩影视网片库每日更新，新片上线速度行业领先。日本电影和韩国电影的最新资源通常在首映后24-48小时内完成中文字幕同步。您可以通过「最新动态」模块查看每日更新内容。',
  },
  {
    q: '播放卡顿怎么办？',
    a: '日韩影视网采用多线CDN加速技术，通常播放非常流畅。如果遇到卡顿，建议：1）切换到较低清晰度；2）检查网络连接；3）刷新页面重试；4）避开网络高峰期观看。绝大多数情况下，韩国电影免费在线观看体验都很流畅。',
  },
  {
    q: '有没有地区限制？',
    a: '日韩影视网面向全球华语用户开放，无论您身在何处，只要能够访问互联网，就可以免费在线观看日韩电影。我们的服务器部署在全球多个节点，确保不同地区的用户都能获得流畅的免费日韩电影播放体验。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 text-center">常见问题</h2>
          <p className="text-sm text-foreground-500 mb-8 text-center">关于日韩影视网，你想知道的都在这里</p>
          <div className="space-y-3">
            {FAQS.map((faq, i) => (
              <details key={i} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4 group-open:text-primary-600 transition-colors">
                    {faq.q}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200/70 flex-shrink-0 group-open:bg-primary-100 transition-colors">
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-500 group-open:rotate-180 transition-all text-sm"></i>
                  </div>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}